import React from 'react';
import { roles } from '../../../utils/enum/roleType';
import {
  AgentMenuIcon,
  DashboardMenuIcon,
  SchedulingMenuIcon,
  ProcessMenuIcon,
  UsersMenuIcons,
  BotsMenuIcon,
  ExecutionLogMenuIcon,
  HistoryMenuIcon,
  ScheduledPlanMenuIcon,
  UserIcon,
  RoiCalculatorButtonIcon,
} from '../../../assets';

export default {
  [roles.SuperAdmin]: [
    {
      key: 1,
      content: 'Dashboard',
      icon: <DashboardMenuIcon className="menuIcon" />,
      link: '/controlroom',
    },
    {
      key: 2,
      content: 'Agents',
      icon: <AgentMenuIcon className="menuIcon" />,
      link: '/controlroom/agents',
    },
    {
      key: 4,
      content: 'Process',
      icon: <ProcessMenuIcon className="menuIcon" />,
      link: '/controlroom/process',
    },
    {
      key: 14,
      title: 'Scheduling',
      icon: <SchedulingMenuIcon className="subMenuIcon" />,
      link: '/controlroom/process/schedule',
      children: [
        {
          key: 15,
          content: 'Scheduled Plans',
          link: '/controlroom/process/schedule/all',
          icon: <ScheduledPlanMenuIcon className="menuIcon" />,
        },
        {
          key: 16,
          content: 'History',
          link: '/controlroom/process/schedule/history',
          icon: <HistoryMenuIcon className="menuIcon" />,
        },
      ],
    },
    {
      key: 5,
      content: 'Execution Logs',
      icon: <ExecutionLogMenuIcon className="menuIcon" />,
      link: '/controlroom/process/logs',
    },
    {
      key: 10,
      content: 'Bots',
      icon: <BotsMenuIcon className="menuIcon" />,
      link: '/controlroom/bots/view',
    },
    {
      key: 612,
      content: 'Manage Users',
      icon: <UsersMenuIcons className="menuIcon" />,
      link: '/controlroom/user',
    },
    {
      key: 613,
      content: 'ROI Configuration',
      icon: <RoiCalculatorButtonIcon className="menuIcon" />,
      link: '/controlroom/roi-configuration',
    },
    {
      key: 61,
      content: 'User Profile',
      icon: <UserIcon className="menuIcon" />,
      link: '/controlroom/profile',
    },
  ],
  [roles.SubAdmin]: [
    {
      key: 1,
      content: 'Dashboard',
      icon: <DashboardMenuIcon className="menuIcon" />,
      link: '/controlroom',
    },
    {
      key: 2,
      content: 'Agents',
      icon: <AgentMenuIcon className="menuIcon" />,
      link: '/controlroom/agents',
    },
    {
      key: 4,
      content: 'Process',
      icon: <ProcessMenuIcon className="menuIcon" />,
      link: '/controlroom/process',
    },
    {
      key: 14,
      title: 'Scheduling',
      icon: <SchedulingMenuIcon className="subMenuIcon" />,
      link: '/controlroom/process/schedule',
      children: [
        {
          key: 15,
          content: 'Scheduled Plans',
          link: '/controlroom/process/schedule/all',
          icon: <ScheduledPlanMenuIcon className="menuIcon" />,
        },
        {
          key: 16,
          content: 'History',
          link: '/controlroom/process/schedule/history',
          icon: <HistoryMenuIcon className="menuIcon" />,
        },
      ],
    },
    {
      key: 5,
      content: 'Execution Logs',
      icon: <ExecutionLogMenuIcon className="menuIcon" />,
      link: '/controlroom/process/logs',
    },
    {
      key: 10,
      content: 'Bots',
      icon: <BotsMenuIcon className="menuIcon" />,
      link: '/controlroom/bots/view',
    },
    {
      key: 612,
      content: 'Manage Users',
      icon: <UsersMenuIcons className="menuIcon" />,
      link: '/controlroom/user',
    },
    {
      key: 61,
      content: 'User Profile',
      icon: <UserIcon className="menuIcon" />,
      link: '/controlroom/profile',
    },
  ],
  [roles.CustomerAdmin]: [
    {
      key: 1,
      content: 'Dashboard',
      icon: <DashboardMenuIcon className="menuIcon" />,
      link: '/controlroom',
    },
    {
      key: 2,
      content: 'Agents',
      icon: <AgentMenuIcon className="menuIcon" />,
      link: '/controlroom/agents',
    },
    {
      key: 4,
      content: 'Process',
      icon: <ProcessMenuIcon className="menuIcon" />,
      link: '/controlroom/process',
    },
    {
      key: 14,
      title: 'Scheduling',
      icon: <SchedulingMenuIcon className="subMenuIcon" />,
      link: '/controlroom/process/schedule',
      children: [
        {
          key: 15,
          content: 'Scheduled Plans',
          link: '/controlroom/process/schedule/all',
          icon: <ScheduledPlanMenuIcon className="menuIcon" />,
        },
        {
          key: 16,
          content: 'History',
          link: '/controlroom/process/schedule/history',
          icon: <HistoryMenuIcon className="menuIcon" />,
        },
      ],
    },
    {
      key: 5,
      content: 'Execution Logs',
      icon: <ExecutionLogMenuIcon className="menuIcon" />,
      link: '/controlroom/process/logs',
    },
    {
      key: 10,
      content: 'Bots',
      icon: <BotsMenuIcon className="menuIcon" />,
      link: '/controlroom/bots/view',
    },
    {
      key: 612,
      content: 'Manage Users',
      icon: <UsersMenuIcons className="menuIcon" />,
      link: '/controlroom/user',
    },
    {
      key: 61,
      content: 'User Profile',
      icon: <UserIcon className="menuIcon" />,
      link: '/controlroom/profile',
    },
  ],
  [roles.User]: [
    {
      key: 1,
      content: 'Dashboard',
      icon: <DashboardMenuIcon className="menuIcon" />,
      link: '/controlroom',
    },
    {
      key: 2,
      content: 'Agents',
      icon: <AgentMenuIcon className="menuIcon" />,
      link: '/controlroom/agents',
    },
    {
      key: 4,
      content: 'Process',
      icon: <ProcessMenuIcon className="menuIcon" />,
      link: '/controlroom/process',
    },
    {
      key: 14,
      title: 'Scheduling',
      icon: <SchedulingMenuIcon className="subMenuIcon" />,
      link: '/controlroom/process/schedule',
      children: [
        {
          key: 15,
          content: 'Scheduled Plans',
          link: '/controlroom/process/schedule/all',
          icon: <ScheduledPlanMenuIcon className="menuIcon" />,
        },
        {
          key: 16,
          content: 'History',
          link: '/controlroom/process/schedule/history',
          icon: <HistoryMenuIcon className="menuIcon" />,
        },
      ],
    },
    {
      key: 5,
      content: 'Execution Logs',
      icon: <ExecutionLogMenuIcon className="menuIcon" />,
      link: '/controlroom/process/logs',
    },
    {
      key: 10,
      content: 'Bots',
      icon: <BotsMenuIcon className="menuIcon" />,
      link: '/controlroom/bots/view',
    },
    {
      key: 61,
      content: 'User Profile',
      icon: <UserIcon className="menuIcon" />,
      link: '/controlroom/profile',
    },
  ],
};
